const router = [
  {
    path: 'publish/personal',
    name: 'personal-post',
    component: () => import('@/modules/Documents/publish/pages/Personal'),
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      action: 4
    },
  },
  {
    path: 'publish/generic',
    name: 'generic-post',
    component: () => import('@/modules/Documents/publish/pages/Generic'),
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      action: 302
    },
  },
  {
    path: 'publish/signature-reminder',
    name: 'user-reminder',
    component: () => import('@/modules/Documents/publish/pages/Reminder.vue'),
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      action: 50
    },
  }
]

export default router